import { Box } from "@mui/material";
import { ReactComponent as IconDiamond } from "../images/icon-diamond.svg";

const styles = {
  alert: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    bgcolor: "#D3E3EB !important",
    width: "fit-content",
    fontsize: "14px",
    padding: "0 8px",
    borderRadius: "4px",
    marginTop: "8px",
  },
  text: {
    margin: 0,
    color: "#1E729F",
    fontFamily: "Nunito",
    fontSize: "14px",
    lineHeight: "19.1px",
  },
};
export default function AlertContainer() {
  return (
    <Box sx={styles.alert}>
      <IconDiamond fill="#1E729F" />
      <p style={styles.text}>
        Este marcador indica campos de preenchimento obrigatório.
      </p>
    </Box>
  );
}
